import { setBillingEntity } from "store/actions/lookups";
import { actions } from "../actions";

const initialState = {
  countries: [],
  cities: [],
  domains: [],
  subDomains: [],
  languages: [],
  nationalities: [],
  services: [],
  timezones: [],
  currencies: [],
  poStatuses: [],
  billingEntity: [],
};

export const lookupsReducers = {
  countries(countries = initialState.countries, action) {
    switch (action.type) {
      case actions.VM_SET_COUNTRIES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return countries;
    }
  },

  cities(cities = initialState.cities, action) {
    switch (action.type) {
      case actions.VM_SET_CITIES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return cities;
    }
  },

  domains(domains = initialState.domains, action) {
    switch (action.type) {
      case actions.VM_SET_DOMAINS:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return domains;
    }
  },

  subDomains(subDomains = initialState.subDomains, action) {
    switch (action.type) {
      case actions.VM_SET_SUB_DOMAINS:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return subDomains;
    }
  },

  languages(languages = initialState.languages, action) {
    switch (action.type) {
      case actions.VM_SET_LANGUAGES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return languages;
    }
  },

  nationalities(nationalities = initialState.nationalities, action) {
    switch (action.type) {
      case actions.VM_SET_NATIONALITIES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return nationalities;
    }
  },

  services(services = initialState.services, action) {
    switch (action.type) {
      case actions.VM_SET_SERVICES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return services;
    }
  },

  timezones(timezones = initialState.timezones, action) {
    switch (action.type) {
      case actions.VM_SET_TIMEZONES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return timezones;
    }
  },

  currencies(currencies = initialState.currencies, action) {
    switch (action.type) {
      case actions.VM_SET_CURRENCIES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return currencies;
    }
  },

  poStatuses(poStatuses = initialState.poStatuses, action) {
    switch (action.type) {
      case actions.VM_SET_PO_STATUSES:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return poStatuses;
    }
  },
  billingEntity(billingEntity = initialState.billingEntity, action) {
    switch (action.type) {
      case actions.VM_SET_BILLING_ENTITY:
        return action.data;
      case actions.VM_RESET_LOOKUPS:
        return [];
      default:
        return billingEntity;
    }
  },
};
